/* __next_internal_client_entry_do_not_use__ PersistStreamedServerComponentRenderer auto */ import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { Suspense, useState, use, useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";
/**
 * ClientCachedStreamedServerComponentRenderer is a React functional component that conditionally renders
 * either a cached component or a component fetched from a promise, based on the `persistCache` prop.
 *
 * <ClientCachedStreamedServerComponentRenderer
 *   renderedComponentPromise={yourComponentPromise}
 *   loadingSkeleton={<LoadingSkeleton />}
 *   suspenseKey="unique-key"
 * />
 */ export var PersistStreamedServerComponentRenderer = function(param) {
    var renderedComponentPromise = param.renderedComponentPromise, loadingSkeleton = param.loadingSkeleton, suspenseKey = param.suspenseKey;
    var _useState = _sliced_to_array(useState(undefined), 2), savedComponent = _useState[0], setSavedComponent = _useState[1];
    useEffect(function() {
        renderedComponentPromise.then(function(component) {
            setSavedComponent(component);
        });
    }, [
        renderedComponentPromise
    ]);
    return /*#__PURE__*/ _jsx(ErrorBoundary, {
        fallback: /*#__PURE__*/ _jsx(_Fragment, {
            children: savedComponent || loadingSkeleton
        }),
        children: /*#__PURE__*/ _jsx(Suspense, {
            fallback: savedComponent || loadingSkeleton,
            children: /*#__PURE__*/ _jsx(WithPromise, {
                renderedComponentPromise: renderedComponentPromise
            })
        }, suspenseKey)
    });
};
var WithPromise = function(param) {
    var renderedComponentPromise = param.renderedComponentPromise;
    var component = use(renderedComponentPromise);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: component
    });
};
